import { FieldErrors } from "react-hook-form";

import { TicketingPaymentInput } from "@/types/ticketing";

export const findStep1FirstErrorPath = (fieldError: FieldErrors<TicketingPaymentInput>): string | null => {
  if (!fieldError.customAnswersOfParticipants && !fieldError.extraDonation) {
    return null;
  }
  if (!fieldError.customAnswersOfParticipants) {
    return "extraDonation";
  }

  const firstInvalidAnswerOfParticipantIndex = Number(
    Object.keys(fieldError.customAnswersOfParticipants).find(
      (key) => fieldError.customAnswersOfParticipants && fieldError.customAnswersOfParticipants[Number(key)]?.answers
    )
  );
  const firstParticipant = fieldError.customAnswersOfParticipants[firstInvalidAnswerOfParticipantIndex];
  if (!firstParticipant?.answers) {
    return null;
  }

  const firstInvalidAnswerIndex = Number(Object.keys(firstParticipant.answers)[0]);
  const firstAnswer = firstParticipant.answers[firstInvalidAnswerIndex];
  if (firstAnswer?.choiceIds) {
    /* Note: Should be equivalent to firstAnswer.choiceIds["ref"].name */
    return `customAnswersOfParticipants.${firstInvalidAnswerOfParticipantIndex}.answers.${firstInvalidAnswerIndex}.choiceIds`;
  }

  if (!firstAnswer?.answers) {
    return null;
  }

  const firstErrorMessageIndex = Number(Object.keys(firstAnswer.answers)[0]);
  return `customAnswersOfParticipants.${firstInvalidAnswerOfParticipantIndex}.answers.${firstInvalidAnswerIndex}.answers.${firstErrorMessageIndex}`;
};
